module.exports = __webpack_public_path__ + "img/huixintg.c1e4ab78.png";